import { useEffect, useState } from 'react'

/**
 * Handles cross-launch from the admin portal.
 * Reads a short-lived JWT from the URL hash fragment, stores it in localStorage,
 * and does a full page reload so AuthContext initializes with the new token.
 */
export default function PlatformAuthPage() {
  const [error, setError] = useState(null)

  useEffect(() => {
    const token = window.location.hash.slice(1)
    if (!token) {
      setError('No authentication token provided.')
      return
    }

    // Store token and full-reload to root so AuthContext picks it up fresh
    localStorage.setItem('localAuthToken', token)

    // Clear any stale impersonation/tenant state from a previous cross-launch
    localStorage.removeItem('platformImpersonating')
    localStorage.removeItem('platformTenantId')
    localStorage.removeItem('platformTenantName')

    // Decode JWT claims to set up impersonation and tenant context in localStorage.
    // PlatformContext reads these keys on init, so headers and banner work automatically.
    try {
      const payload = JSON.parse(atob(token.split('.')[1]))
      if (payload.impersonate_email) {
        localStorage.setItem('platformImpersonating', JSON.stringify({
          email: payload.impersonate_email,
          name: payload.impersonate_name || payload.impersonate_email
        }))
        if (payload.tenant_id) {
          localStorage.setItem('platformTenantId', String(payload.tenant_id))
          localStorage.setItem('platformTenantName', payload.tenant_name || '')
        }
      }
    } catch {
      // Non-fatal — launch proceeds without impersonation context
    }

    window.location.replace('/')
  }, [])

  if (error) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4">
        <div className="text-center">
          <p className="text-red-400 mb-4">{error}</p>
          <a href="/login" className="text-amber-500 hover:text-amber-400 text-sm">
            Go to login
          </a>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-amber-500" />
    </div>
  )
}
